module.exports = __webpack_public_path__ + "img/1.584bf45c.png";